<template>
  <div class="dashboard">
    <div class="metrics" v-if="metrics">
      <KPICard
        :title="onlineAudiologists"
        :subtitle="$t('evocall.dashboard.online_audiologists')"
      >
        <template slot="description" v-if="audiologistsInBreak > 0">
          <span class="text-default-color"> {{`${$t('evocall.dashboard.audiologists_in_break')}: ${audiologistsInBreak}`}} </span>
        </template>
      </KPICard>

      <KPICard
        :title="metrics.ongoingCalls"
        :subtitle="$t('evocall.dashboard.on_going')"
      >
        <template slot="description">
          <span>
            {{ $t('evocall.dashboard.average_call_duration') }}
          </span>
          <span>
            {{ getRelativeTimeString(metrics.averageCallDuration) }}
          </span>
        </template>
      </KPICard>

      <KPICard
        :title="requests.length"
        :subtitle="$t('evocall.dashboard.waiting_time')"
      >
        <template slot="description">
          <span>
            {{ $t('evocall.dashboard.average_waiting_time') }}
          </span>
          <span>
            {{ getRelativeTimeString(metrics.averageWaitingTime) }}
          </span>
        </template>
      </KPICard>

      <KPICard
        id="priorities-card"
        :title="requests.filter(elem => parseInt(elem.priority.id) === 3).length"
        :subtitle="$t('evocall.dashboard.priority')"
      >
        <template slot="description">

          <div class="card__container__main__description--high">
            <i class="fa fa-angle-up"></i>&nbsp;
            <span class="content">{{highPriorityPercentage}} %</span>
          </div>
          <div class="card__container__main__description--normal">
            <i class="fa fa-minus"></i>&nbsp;
            <span class="content"> {{ normalPriorityPercentage }} %</span>
          </div>
          <div class="card__container__main__description--low">
            <i class="fa fa-angle-down"></i>&nbsp;
            <span class="content"> {{ lowPriorityPercentage }} %</span>
          </div>
        </template>
      </KPICard>

    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import RelativeTimeMixin from '@/mixins/RelativeTimeMixin'
import KPICard from '@/components/common/KPICard'
import SocketioService from "@/services/socketio.service";
export default {
  props: {
    waitingRoomModuleKey: {
      type: String,
      required: true
    },
  },
  components: {
    KPICard
  },
  mixins: [
    RelativeTimeMixin
  ],
  created () {
    //this.$store.dispatch(`${this.waitingRoomModuleKey}/GET_METRICS`)
    //SocketioService.getMetrics(this.$auth.user().id)
  },
  computed: {
    ...mapState({
      metrics (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/metrics`] || null
      },
      requests (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/requests`] || null
      },
      onlineAudiologistsResume (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/onlineAudiologists`] || null
      },
      priorities (state) {
        return state[this.waitingRoomModuleKey].priorities || {}
      }
    }),
    onlineAudiologists: function (value) {
      return this.onlineAudiologistsResume ? this.onlineAudiologistsResume.online : 0
    },
    audiologistsInBreak: function () {
      return this.onlineAudiologistsResume !== undefined ? this.onlineAudiologistsResume.inBreak : 0
    },
    highPriorityPercentage: function () {
      if (this.requests.length) {
        const highRequests = this.requests.filter(elem => parseInt(elem.priority.id) === 3)
        return ((highRequests.length / this.requests.length) * 100).toFixed(1)
      }
      return 0
    },
    normalPriorityPercentage: function () {
      if (this.requests.length) {
        const normalRequests = this.requests.filter(elem => parseInt(elem.priority.id) === 2)
        return ((normalRequests.length / this.requests.length) * 100).toFixed(1)
      }
      return 0
    },
    lowPriorityPercentage: function () {
      if (this.requests.length) {
        const lowRequests = this.requests.filter(elem => parseInt(elem.priority.id) === 1)
        return ((lowRequests.length / this.requests.length) * 100).toFixed(1)
      }
      return 0
    }
  }
}
</script>

<style lang="scss">

@mixin for-desktop {
  @media (min-width: 766px) {
    @content;
  }
}

@mixin for-desktop-xl {
  @media (min-width: 1336px) {
    @content;
  }
}

$primary-light-gray: #6E6E6E;
$primary-red: #c42940;
$primary-yellow: #c49d29;
$primary-green: #29c4aa;

.dashboard {

  .metrics {

    display: flex;
    flex-direction: column;
    align-items: stretch;

    @include for-desktop {
      flex-direction: row;
      justify-content: space-around;
    }

    .kpi-card {
      width: 100%;

      @include for-desktop {
        width: 21.5%;
      }

      &#priorities-card .card__container__main__description {
        flex-direction: row;

        & span.content {
          font-size: 0.825rem;
          color: $primary-light-gray;
        }
        &--high {
          & i {
            font-size: 1.3rem;
            color: $primary-red;
          }
        }

        &--normal {
          & i {
            font-size: 1rem;
            color: $primary-yellow;
          }
        }

        &--low {
          & i {
            font-size: 1.3rem;
            color: $primary-green;
          }
        }

      }
    }
  }
}
</style>
